import { render, staticRenderFns } from "./bIntroSliderView.vue?vue&type=template&id=19c52c42&scoped=true"
import script from "./bIntroSliderView.vue?vue&type=script&lang=js"
export * from "./bIntroSliderView.vue?vue&type=script&lang=js"
import style0 from "./bIntroSliderView.vue?vue&type=style&index=0&id=19c52c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c52c42",
  null
  
)

export default component.exports